// extracted by mini-css-extract-plugin
module.exports = {"main":"burger-constructor_main__2pi_T","dropArea":"burger-constructor_dropArea__1mA-o","submit":"burger-constructor_submit__MlLPx","total":"burger-constructor_total__1SDlJ"};